import React from 'react';
import CursorApiManager from '../components/CursorApiManager';

const DataImportPage = () => {
  return (
    <div className="p-6">
      <CursorApiManager />
    </div>
  );
};

export default DataImportPage;